import React, { MouseEvent } from 'react';
import { observer } from 'mobx-react';
import { Catcher, LoadingApiByIds } from '../../';
import { HorizontalUsageChart } from './HorizontalUsageChart';
import { useDashboardCompanyUsageChart, useRouterStore } from '../../../hooks';
import { tI, tP } from '../../../translate';
import Styles from '../m_dashboarStyles.less';

export const CompanyUsage: React.FC = observer(() => {
    const data = useDashboardCompanyUsageChart();
    const routerStore = useRouterStore();
    const title = `${tP('Top Companies')} ${tI('by Usage')}`;
    const goToCompanyList = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
        event.preventDefault();
        routerStore.goTo('CompaniesList');
    };

    const titleLink = (): JSX.Element => (
        <a onClick={goToCompanyList} href={`/companies`}>
            {title}
        </a>
    );
    const goToCompany = (id: string): void => {
        routerStore.goTo('Company', { params: { id } });
    };

    return (
        <Catcher>
            <LoadingApiByIds idSpinners={['GET_USAGE_COMPANY_LIST']} />
            <div className={Styles.chart}>
                <HorizontalUsageChart
                    sourceData={data}
                    title={title}
                    titleLink={titleLink()}
                    onSelectRow={goToCompany}
                />
            </div>
        </Catcher>
    );
});
